import request from '../utils/request'

export function getAdminUnreadMessageCount() {
  return request({
    url: '/api/admin/ops/messages/unread-count',
    method: 'get'
  })
}

export function getAdminRecentMessages() {
  return request({
    url: '/api/admin/ops/messages/recent',
    method: 'get'
  })
}

export function getAdminMessages() {
  return request({
    url: '/api/admin/ops/messages',
    method: 'get'
  })
}

export function getAdminMessageDetail(id) {
  return request({
    url: `/api/admin/ops/messages/${id}`,
    method: 'get'
  })
}

export function markAdminMessageRead(id) {
  return request({
    url: `/api/admin/ops/messages/${id}/read`,
    method: 'post'
  })
}

export function markAdminAllMessagesRead() {
  return request({
    url: '/api/admin/ops/messages/read-all',
    method: 'post'
  })
}

export function createAdminMessageTask(data) {
  return request({
    url: '/api/admin/ops/message-tasks',
    method: 'post',
    data
  })
}

export function getAdminMessageTasks() {
  return request({
    url: '/api/admin/ops/message-tasks',
    method: 'get'
  })
}

export function getAdminMessageTaskDetail(id) {
  return request({
    url: `/api/admin/ops/message-tasks/${id}`,
    method: 'get'
  })
}

export function getAdminMessageTaskDetails(id) {
  return request({
    url: `/api/admin/ops/message-tasks/${id}/details`,
    method: 'get'
  })
}
